import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlContrato = '/service/documentos/'

class ArquivosAnexosService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultarAnexos(filtro) {
        let data = {
            exercicio: filtro.exercicio,
            numero: filtro.numero,
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlContrato + 'anexosRecursoConcedido/', JSON.stringify(data))
    }

    consultarAnexosObrasParadas(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlContrato + 'anexosObrasParadas/', JSON.stringify(data))
    }

    consultarAnexosPlanosAnuaisContratacoes(filtro) {
        let data = {
            origem: filtro.origem,
        }
        return this.conex.post(urlContrato + 'anexosPlanosAnualContratacao/', JSON.stringify(data))
    }

    consultarAnexosDespesasCartaoCorporativo(filtro) {
        let data = {
            linkExtratoCartao: filtro.linkExtratoCartao,
        }
        return this.conex.post(urlContrato + 'anexosDespesasCartaoCorporativo/', JSON.stringify(data))
    }

    consultarAnexosPrestacaoContasAnual(filtro) {
        let data = {
            sequencial: filtro.sequencial,
        }
        return this.conex.post(urlContrato + 'anexosPrestacaoContasAnual/', JSON.stringify(data))
    }

    consultarAnexosDetalhesAdvertenciaFornecedor(filtro) {
        let data = {
            sequencial: filtro.sequencial,
            exercicioAdiantamento: filtro.exercicioAdiantamento,
            numeroAdiantamento: filtro.numeroAdiantamento,
        }
        return this.conex.post(urlContrato + 'detalhesAdiantamentosSuprimentos/', JSON.stringify(data))
    }

    consultarAnexosDetalhesPrestacao(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlContrato + 'arquivosDetalhesPrestacao/', JSON.stringify(data))
    }
}

export default ArquivosAnexosService
